var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.9215 0C1.30312 0 0 1.30312 0 2.9215V13.0785C0 14.6969 1.30312 16 2.9215 16H8.42649V9.74499H6.7725V7.49299H8.42649V5.569C8.42649 4.0574 9.40376 2.6695 11.655 2.6695C12.5665 2.6695 13.2405 2.757 13.2405 2.757L13.1875 4.86001C13.1875 4.86001 12.5001 4.85351 11.75 4.85351C10.9382 4.85351 10.808 5.22756 10.808 5.84852V7.49301H13.252L13.1455 9.745H10.808V16H13.0785C14.6968 16 16 14.6969 16 13.0785V2.92151C16 1.30313 14.6968 1.6e-05 13.0785 1.6e-05H2.92148L2.9215 0Z",
    fill: "#EFEFEF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookFooter);
export default __webpack_public_path__ + "static/media/Facebook_Footer.c768367594d1a6816c572ebf7e70930c.svg";
export { ForwardRef as ReactComponent };